import "../constants/const.css";
import "./css/pageLogin.css";

import Button from "../components/buttonBase";
import passON from "../image/passON.png";
import passOFF from "../image/passOFF.png";
import React, { useState, useContext, createRef } from "react";
import { ENV_TITLE_TEXT } from "../constants/const";
import { useApi, REQ_AUTH_USER } from "../logic/classApi";
import type { JsonResponse } from "../logic/classApi";
import { LoginContext } from "../context/loginContext";
import { showErrorMessage } from "../components/appPane";
import { MESSAGES } from "../constants/const";
import useCookie from "../logic/cookie";

interface ButtonProps {
  redirect: () => void;
}

const Page: React.FC<ButtonProps> = ({ redirect }) => {
  const { postRequestJson } = useApi();
  const { setIsLogin } = useContext(LoginContext);
  const [, cookieHandle] = useCookie();

  const [showPassword, setShowPassword] = useState(false);

  const inputUserId = createRef<HTMLInputElement>();
  const inputPassword = createRef<HTMLInputElement>();

  const auth = async (e: React.FormEvent) => {
    e.preventDefault();

    if (inputUserId.current?.value && inputPassword.current?.value) {
      const { status, payload: response } = await postRequestJson<JsonResponse>(REQ_AUTH_USER, {
        userId: inputUserId.current?.value,
        password: inputPassword.current?.value,
      });
      if (status === 200 && "branchCode" in response) {
        cookieHandle.setCookies(
          response.branchCode,
          response.branchName,
          response.branchFurnaces,
          response.branchFunenWeek,
          response.userName,
          response.permissionId,
          response.permission1,
          response.permission2,
          response.permission3
        );
        setIsLogin(true);
        redirect();
      } else {
        setIsLogin(false);
        showErrorMessage(MESSAGES.ERROR_AUTH);
      }
    } else {
      setIsLogin(false);
      showErrorMessage(MESSAGES.ERROR_AUTH);
    }
  };

  const handlePassClear = () => {
    setShowPassword(!showPassword);
  };

  return (
    <>
      <div className="h-full w-full screen-panel">
        <div className="login-panel">
          <div className="system-title">{`薬剤管理システム${ENV_TITLE_TEXT}`}</div>

          <div className="main-panel">
            <hr className="login-hr"></hr>
            <form onSubmit={auth}>
              <div className="split-panel">
                <input
                  ref={inputUserId}
                  className="user-input"
                  type="text"
                  placeholder="ユーザID"
                  required
                />
              </div>

              <div className="split-panel">
                <input
                  ref={inputPassword}
                  className="user-input"
                  type={showPassword ? "text" : "password"}
                  placeholder="パスワード"
                  required
                />
                <span onClick={handlePassClear}>
                  <img
                    className="pass-mask"
                    src={showPassword ? passON : passOFF}
                    alt="button"
                    width="25px"
                    height="25px"
                  ></img>
                </span>
              </div>
              <Button className="login-button" type="submit">
                ログイン
              </Button>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default Page;
